/**
 * 各按需模块初始化上下文构建器
 */

export function buildBookshelfInteractionsInitContext(deps = {}) {
  const {
    state,
    elements,
    showEditCollectionMenu,
    showAddCollectionModal,
    showAllCollectionsModal,
    renderBookshelf,
    showBookDetail,
    toggleBookSelection,
    openBook,
    enterSelectMode,
    saveCollections,
    saveGlobalShelfOrder,
    renderCollectionFilters,
    updateBooksOrder,
    showToast
  } = deps;

  return {
    state,
    elements,
    showEditCollectionMenu,
    showAddCollectionModal,
    showAllCollectionsModal,
    renderBookshelf,
    showBookDetail,
    toggleBookSelection,
    openBook,
    enterSelectMode,
    saveCollections,
    saveGlobalShelfOrder,
    renderCollectionFilters,
    updateBooksOrder,
    showToast
  };
}

export function buildAppEventBindingsInitContext(deps = {}) {
  const {
    elements,
    state,
    switchView,
    setupBookshelfDelegatedEvents,
    exitSelectMode,
    renderBookshelf,
    setViewMode,
    renderBooklistView,
    syncUnifiedSearchUi,
    handlePrimaryActionClick,
    handleFileSelect,
    toggleSiteTheme,
    setupSiteThemeLongPressFullscreen,
    toggleSortMenu,
    handleSort,
    updateWelcomeMessage,
    handleSearch,
    clearSearch,
    openThoughtModal,
    createNewEssay,
    deleteCurrentEssay,
    handleEssayTitleChange,
    toggleEssaysSidebar,
    closeReader,
    navigatePage,
    handleHighlight,
    openQuickThought,
    toggleToc,
    setupSelectionToolbar,
    ensureReaderDisplayModeModuleReady,
    ensureReaderUiPanelsModuleReady,
    ensureReaderRenderSizingModuleReady,
    ensureReaderQuickThoughtModuleReady,
    handleTocSearch,
    clearTocSearch,
    togglePanel,
    toggleFullscreen,
    changeFontSize,
    changeLineHeight,
    changeFontFamily,
    changeTheme,
    setupReaderOverlayOutsideCloseEvents,
    closeModal,
    ensureReaderKeyboardModuleReady,
    handleKeyboard,
    handleDrop,
    deleteSelectedBooks,
    showBatchCategoryModal,
    showBatchCollectionModal,
    bindAiLazyEntrypoints,
    setupEnhancedReaderEvents,
    syncThoughtsScrollbarGutter
  } = deps;

  return {
    elements,
    state,
    switchView,
    setupBookshelfDelegatedEvents,
    exitSelectMode,
    renderBookshelf,
    setViewMode,
    renderBooklistView,
    syncUnifiedSearchUi,
    handlePrimaryActionClick,
    handleFileSelect,
    toggleSiteTheme,
    setupSiteThemeLongPressFullscreen,
    toggleSortMenu,
    handleSort,
    updateWelcomeMessage,
    handleSearch,
    clearSearch,
    openThoughtModal,
    createNewEssay,
    deleteCurrentEssay,
    handleEssayTitleChange,
    toggleEssaysSidebar,
    closeReader,
    navigatePage,
    handleHighlight,
    openQuickThought,
    toggleToc,
    setupSelectionToolbar,
    ensureReaderDisplayModeModuleReady,
    ensureReaderUiPanelsModuleReady,
    ensureReaderRenderSizingModuleReady,
    ensureReaderQuickThoughtModuleReady,
    handleTocSearch,
    clearTocSearch,
    togglePanel,
    toggleFullscreen,
    changeFontSize,
    changeLineHeight,
    changeFontFamily,
    changeTheme,
    setupReaderOverlayOutsideCloseEvents,
    closeModal,
    ensureReaderKeyboardModuleReady,
    handleKeyboard,
    handleDrop,
    deleteSelectedBooks,
    showBatchCategoryModal,
    showBatchCollectionModal,
    bindAiLazyEntrypoints,
    setupEnhancedReaderEvents,
    syncThoughtsScrollbarGutter
  };
}

export function buildViewNavigationInitContext(deps = {}) {
  const {
    state,
    elements,
    exitSelectMode,
    syncUnifiedSearchUi,
    renderCurrentView,
    ensureThoughtsModuleReady,
    renderThoughtsView,
    ensureHighlightsModuleReady,
    renderHighlights,
    ensureBooklistModuleReady,
    renderBooklistView,
    showToast,
    showManageBooklistBooksModal,
    showAddBooklistModal,
    canAccessFeature,
    isAdmin,
    openMembershipCenter
  } = deps;

  return {
    state,
    elements,
    exitSelectMode,
    syncUnifiedSearchUi,
    renderCurrentView,
    ensureThoughtsModuleReady,
    renderThoughtsView,
    ensureHighlightsModuleReady,
    renderHighlights,
    ensureBooklistModuleReady,
    renderBooklistView,
    showToast,
    showManageBooklistBooksModal,
    showAddBooklistModal,
    canAccessFeature,
    isAdmin,
    openMembershipCenter
  };
}

export function buildCategoryCollectionFiltersInitContext(deps = {}) {
  const {
    state,
    elements,
    showEditCategoryMenu,
    showAllCategoriesModal,
    showAddCategoryModal,
    renderBookshelf,
    escapeHtml,
    showEditCollectionMenu,
    showAllCollectionsModal,
    showAddCollectionModal,
    sortCollections
  } = deps;

  return {
    state,
    elements,
    showEditCategoryMenu,
    showAllCategoriesModal,
    showAddCategoryModal,
    renderBookshelf,
    escapeHtml,
    showEditCollectionMenu,
    showAllCollectionsModal,
    showAddCollectionModal,
    sortCollections
  };
}

export function buildBatchSelectionInitContext(deps = {}) {
  const {
    state,
    elements,
    renderBookshelf,
    openModal,
    closeModal,
    showToast,
    deleteBook,
    removeBooksFromAllCollections,
    removeBooksFromAllBooklists,
    updateBook,
    saveCategories,
    renderCategoryFilters,
    escapeHtml
  } = deps;

  return {
    state,
    elements,
    renderBookshelf,
    openModal,
    closeModal,
    showToast,
    deleteBook,
    removeBooksFromAllCollections,
    removeBooksFromAllBooklists,
    updateBook,
    saveCategories,
    renderCategoryFilters,
    escapeHtml
  };
}

export function buildBooklistInitContext(deps = {}) {
  const {
    state,
    elements,
    showToast,
    openModal,
    closeModal,
    syncUnifiedSearchUi,
    showEditBooklistMenu,
    showAllBooklistsModal,
    confirmDeleteBook,
    showBookDetail,
    openBook,
    saveBooklists,
    updateShelfViewModeButton,
    updatePrimaryActionButton,
    generateBooklistId,
    sortBooksForBooklist,
    sortBooklists,
    createBooklistActionCardHtml,
    createBooklistActionListItemHtml,
    createBookCard,
    createBookListItem
  } = deps;

  return {
    state,
    elements,
    showToast,
    openModal,
    closeModal,
    syncUnifiedSearchUi,
    showEditBooklistMenu,
    showAllBooklistsModal,
    confirmDeleteBook,
    showBookDetail,
    openBook,
    saveBooklists,
    updateShelfViewModeButton,
    updatePrimaryActionButton,
    generateBooklistId,
    sortBooksForBooklist,
    sortBooklists,
    createBooklistActionCardHtml,
    createBooklistActionListItemHtml,
    createBookCard,
    createBookListItem
  };
}

export function buildBookDetailInitContext(deps = {}) {
  const {
    state,
    elements,
    showToast,
    openModal,
    closeModal,
    openBook,
    confirmDeleteBook,
    saveCategories,
    saveCollections,
    renderBookshelf,
    renderCollectionFilters,
    updateBook,
    generateCollectionId,
    escapeHtml
  } = deps;

  return {
    state,
    elements,
    showToast,
    openModal,
    closeModal,
    openBook,
    confirmDeleteBook,
    saveCategories,
    saveCollections,
    renderBookshelf,
    renderCollectionFilters,
    updateBook,
    generateCollectionId,
    escapeHtml
  };
}

export function buildLibraryModalsInitContext(deps = {}) {
  const {
    state,
    elements,
    showToast,
    openModal,
    closeModal,
    saveCategories,
    saveCollections,
    saveBooklists,
    updateBook,
    renderCategoryFilters,
    renderCollectionFilters,
    renderBookshelf,
    renderBooklistView,
    renderCurrentView,
    switchView,
    showAddBooklistModal,
    getBooklistBookCount,
    generateCollectionId,
    updateGlobalShelfOrderForCollectionOrder,
    addBooksToCollection,
    exitSelectMode,
    escapeHtml
  } = deps;

  return {
    state,
    elements,
    showToast,
    openModal,
    closeModal,
    saveCategories,
    saveCollections,
    saveBooklists,
    updateBook,
    renderCategoryFilters,
    renderCollectionFilters,
    renderBookshelf,
    renderBooklistView,
    renderCurrentView,
    switchView,
    showAddBooklistModal,
    getBooklistBookCount,
    generateCollectionId,
    updateGlobalShelfOrderForCollectionOrder,
    addBooksToCollection,
    exitSelectMode,
    escapeHtml
  };
}

export function buildReaderLifecycleInitContext(deps = {}) {
  const {
    state,
    elements,
    showToast,
    getBook,
    getReadingProgress,
    getReaderConstructor,
    waitForStableElementSize,
    loadToc,
    updateProgressDisplay,
    applyReaderSettings,
    maybeFixInitialRenderSize,
    showShortcutsHint,
    startReadingSession,
    updateBook,
    initEnhancedFeatures,
    applyMobileReaderImmersive,
    renderBookmarks,
    restoreSavedMarks,
    showReadingEstimate,
    endReadingSession,
    cleanupEnhancedFeatures,
    closeAllPanels,
    hideSelectionToolbar,
    syncModalOverlayTheme,
    syncThemeColor,
    saveReadingProgress
  } = deps;

  return {
    state,
    elements,
    showToast,
    getBook,
    getReadingProgress,
    getReaderConstructor,
    waitForStableElementSize,
    loadToc,
    updateProgressDisplay,
    applyReaderSettings,
    maybeFixInitialRenderSize,
    showShortcutsHint,
    startReadingSession,
    updateBook,
    initEnhancedFeatures,
    applyMobileReaderImmersive,
    renderBookmarks,
    restoreSavedMarks,
    showReadingEstimate,
    endReadingSession,
    cleanupEnhancedFeatures,
    closeAllPanels,
    hideSelectionToolbar,
    syncModalOverlayTheme,
    syncThemeColor,
    saveReadingProgress
  };
}

export function buildReaderKeyboardInitContext(deps = {}) {
  const {
    state,
    elements,
    closeAllPanels,
    toggleFullscreen,
    closeReader,
    navigatePage,
    handleHighlight,
    openQuickThought,
    toggleToc,
    addCurrentBookmark,
    showToast,
    toggleDualPageMode,
    togglePanel,
    showShortcutsHint,
    closeModal,
    getTts,
    getAutoScroll,
    getImmersiveMode
  } = deps;

  return {
    state,
    elements,
    closeAllPanels,
    toggleFullscreen,
    closeReader,
    navigatePage,
    handleHighlight,
    openQuickThought,
    toggleToc,
    addCurrentBookmark,
    showToast,
    toggleDualPageMode,
    togglePanel,
    showShortcutsHint,
    closeModal,
    getTts,
    getAutoScroll,
    getImmersiveMode
  };
}
